export default __webpack_public_path__ + "static/media/main.5f47459e.svg";